const helpData = ({ config, access, FILE_MAX_SIZE, SUBSCRIBER_FILE_MAX_SIZE, meta, alt }) => {
  return [
      {
        title: 'Watch quick start video',
        text: '',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/intro-video-preview.png?v=${config.app_version}`,
        imageHeight: '180',
        imageType: 'image',
        key: 'video',
        category: 'video',
        nofaq: true,
      },
      {
        title: 'Create a card',
        text: '<p>A card is the basic unit. It can represent anything - a person, place, object, or any idea at all.</p><p>You can create a card in three different ways: click the card icon in the sidebar, double click on the canvas, or click and drag the card icon from the sidebar onto the canvas.</p>',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/create-a-card.mp4?v=${config.app_version}`,
        imageHeight: '261',
        imageType: 'video',
        key: 'add-idea',
        category: 'basic',
      },
      {
        title: 'Add a part',
        text: '<p>Click add a part when a card is selected.</p><p>Or press enter after creating a part to add another.</p>',
        imageUrl: `/images/add_a_part.mp4?v=${config.app_version}`,
        imageHeight: '299',
        imageType: 'video',
        key: 'add-part',
        category: 'basic',
      },
      {
        title: 'Create a line',
        text: '<p>To create a line, click and drag the arrow that appears above your card on hover to another card. You can also select the line tool in the sidebar - when it appears, drag each endpoint to the two cards you are relating.</p><p>Change the line from an arc to an elbow by using the “Line type“ tool in the toolbar that appears at the top of your map when the line is selected.</p>',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/create+a+relationship.mp4?v=${config.app_version}`,
        imageHeight: '196',
        imageType: 'video',
        key: 'create-relationship',
        category: 'basic',
      },
      {
        title: 'Collaborate & share with others',
        text: '<p>Select the blue Share button in the top right corner of your map. From there you can invite collaborators by email, share a view-only or edit link, share a presentation, or embed your map on your website.</p><p>You can also navigate to where your collaborators’ cursors are in the map by clicking on their avatar.</p>',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/collaborate.mp4?v=${config.app_version}`,
        imageHeight: '186',
        imageType: 'video',
        key: 'collaboration',
        category: 'basic',
      },
      {
        title: 'Save a map',
        text: '<p>Your map activities are being saved for you automatically. Assuming your device is connected to the internet, the changes you make to your map are saved right away.</p>',
        imageType: "none",
        key: "save-map",
        category: 'basic'
      },
      {
        title: 'Customize text',
        text: '<p>By highlighting the text in a card you can change the font size, make it bold, italicize it, or hyperlink it.</p>',
        key: 'customize-text',
        category: 'basic'
      },
      {
        title: 'Space to pan',
        text: '<p>Hold down your space bar while clicking and dragging to avoid grabbing cards as you pan around your map.</p>',
        key: 'space-pan',
        category: 'basic'
      },
      {
        title: 'Privacy and security',
        text: '<p>Your maps are 100% private, unless you decide to proactively share them with a collaborator or viewer. For more information, head to our <a href="/security" target="_blank">security</a>, <a href="/privacy-policy" target="_blank">privacy policy</a>, and <a href="/terms-of-service" target="_blank">terms of service</a> pages.</p>',
        key: 'privacy',
        category: 'privacy',
      },
      {
        text: `<p>To undo any action, press <span class='bold'>${meta} + z</span>. To redo, press  <span class='bold'>${meta} + shift + z</span> or <span class='bold'>${meta} + y</span></p>`,
        title: 'Undo an action',
        key: 'undo',
        category: 'basic',
      },
      {
        title: 'Select multiple cards',
        text: "<p>Hold down <span class='bold'>shift</span> on your keyboard and click individual cards to select them.</p><p>Or hold down <span class='bold'>shift</span> and click and drag to select all cards in a region.</p>",
        imageUrl: `/images/select_multiple_cards.mp4?v=${config.app_version}`,
        imageHeight: '226',
        imageType: 'video',
        key: 'select-multiple',
        category: 'workflow',
      },
      {
        title: 'Group cards',
        text: `<p>Select multiple cards by holding down shift while clicking and dragging, then press <span class='bold'>${meta} + g</span> to create a new card containing the current selection.</p>`,
        imageUrl: `/images/group.mp4?v=${config.app_version}`,
        imageHeight: '251',
        imageType: 'video',
        key: 'group',
        category: 'workflow',
      },
      {
        title: 'Move around a map',
        text: '<p>Click and drag on a blank area of the canvas to move around a map.</p>',
        imageType: 'none',
        key: 'click-drag',
        category: 'workflow',
      },
      {
        title: 'Center a selection in canvas',
        text: `<p>Click the button to the left of the zoom controls to center your current selection in the canvas. If no cards are selected, clicking the button will center the entire map. You can also use <span class='bold'>${meta} + 0</span> on your keyboard.</p>`,
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/center_in_view.mp4?v=${config.app_version}`,
        imageHeight: '183',
        imageType: 'video',
        key: 'zoom-to-fit',
        category: 'workflow',
      },
      {
        title: 'Link to a selection',
        text: `<p>With multiple cards selected, go to the three-dot-menu in the toolbar at the top of the map, and select "link to selection."</p><p>Or press <span class="bold">${meta} + shift + L</span> to copy a link to the current selection to your clipboard.</p>`,
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/link_to_selection.mp4?v=${config.app_version}`,
        imageHeight: '356',
        imageType: 'video',
        key: 'link-to-selection',
        category: 'workflow',
      },
      {
        title: 'Turn off autocomplete',
        text: '<p>Click on your avatar in the upper right hand corner and select Settings from the dropdown menu to toggle autocomplete from Wikipedia or your Ideas library.</p>',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/turn-on-autocomplete.mp4?v=${config.app_version}`,
        imageHeight: '442',
        imageType: 'video',
        key: 'turn-off-autocomplete',
        category: 'workflow',
      },
      {
        title: 'Spellcheck',
        text: '<p>To enable spellcheck, click on your avatar in the upper right hand corner and select Settings from the dropdown menu, then toggle the spellcheck setting.</p>',
        key: 'spellcheck',
        category: 'workflow',
      },
      {
        title: 'Change background color',
        text: '<p>To change the default background color on all of your maps, click on your avatar in the top right corner of your map and navigate to the Settings menu. There you can switch between white and grey.</p><p>This will only apply to your own maps, and will not be visible to collaborators.</p><p>You can also access the Settings menu by right-clicking on the canvas.</p>',
        key: 'background',
        imageUrl: `https://plectica-app-assets.s3.amazonaws.com/user-guide/change-background.png?v=${config.app_version}`,
        imageHeight: '198',
        imageType: 'image',
        category: 'workflow',
      },
      {
        title: 'Focus mode',
        text: '<p>To hide all of the tools on the edges of your canvas, select the “Focus mode” icon in the top right corner of your map, to the right of the Help button.</p>',
        key: 'focus',
        imageUrl: `https://plectica-app-assets.s3.amazonaws.com/user-guide/focus-mode.png?v=${config.app_version}`,
        imageHeight: '156',
        imageType: 'image',
        category: 'workflow',
      },
      {
        title: 'Duplicate cards',
        text: `<p>Hold down ${alt} on your keyboard and drag cards to duplicate them.</p>`,
        imageUrl: `/images/duplicate.mp4?v=${config.app_version}`,
        imageHeight: '180.26',
        imageType: 'video',
        key: 'duplicate-cards',
        category: 'workflow',
      },
      {
        title: 'Reuse ideas',
        text: '<p>Turn on autocomplete and select autocomplete suggestions to reference canonical ideas from Wikipedia or ideas you have used previously.</p>',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/reuse_ideas.mp4?v=${config.app_version}`,
        imageHeight: '393',
        imageType: 'video',
        key: 'reuse-ideas',
        category: 'workflow',
      },
      {
        title: 'Export a map',
        text: '<p>To export your map as a PDF, image, or as a JSON or CSV file - use the three dot menu to the right of your map’s title and select “Export.”</p><p>If your map has waypoints, you can also export your presentation to PowerPoint, so that each waypoint becomes its own slide.</p>',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/export.png?v=${config.app_version}`,
        imageHeight: '135.7',
        imageType: 'image',
        key: 'export-map',
        category: 'workflow',
      },
      {
        title: 'Print a map',
        text: '<p>Print your map from the PDF or image, or use command+P on your keyboard while inside a map.</p>',
        key: 'print-map',
        category: 'workflow',
      },
      {
        title: 'CSV import',
        text: '<p>To import content into your map from a CSV file, go to the three dot menu to the right of your map’s title, and select "Import."</p>',
        key: 'import-map',
        category: 'workflow',
      },
      {
        title: "View a collaborator's cards",
        text: "<p>Hover over a collaborator in the top right of a map to see the cards they've contributed.</p>",
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/view_collaborators_cards.mp4?v=${config.app_version}`,
        imageHeight: '213',
        imageType: 'video',
        key: 'collaborator-edits',
        category: 'workflow',
      },
      {
        title: "Embed your map on your own website",
        text: `<p>Paste the following HTML code into your blog or website HTML to embed this map.</p><textarea readonly class='rawhtml'>&lt;iframe src=&quot;https://plectica.com/maps/embedded/${access.publicIdentifier}&quot; width=&quot;700&quot; height=&quot;500&quot;&gt; &lt;/iframe&gt;</textarea>`,
        imageUrl: `/images/embed_map.png?v=${config.app_version}`,
        imageHeight: '139.09',
        imageType: 'image',
        key: 'embed-map',
        category: 'workflow',
        nofaq: true,
      },
      {
        title: 'Recent activity',
        text: '<p>Recent activity helps you find what’s changed in a map and playback your mapping process, whether you are working alone or with others.</p><p>In the recent activity panel, you can click on an entry to see those cards in the map, or hit play to see how the map has changed over time.</p>',
        key: 'recent-activity',
        imageUrl: `https://plectica-app-assets.s3.amazonaws.com/user-guide/recent-activity.png?v=${config.app_version}`,
        imageHeight: '172',
        imageType: 'image',
        category: 'workflow',
      },
      {
        title: 'Align cards in a map',
        text: '<p>Open the bulk action menu and look under \'Align\' to align a selection of cards in your map.</p>',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/arrange_cards.mp4?v=${config.app_version}`,
        imageHeight: '236',
        imageType: 'video',
        key: 'align-cards',
        category: 'organization',
      },
      {
        title: 'Change card layouts',
        text: "",
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/change-layouts.png?v=${config.app_version}`,
        imageHeight: '138.66',
        imageType: 'image',
        key: 'change-layouts',
        category: 'organization',
      },
      {
        title: 'Pop out parts',
        text: "<p>Open the card menu and select 'Pop out parts' to 'pop' the parts of a card out and position them as you'd like. Popped-out parts remain tied to their parent card and move with it.</p><p>Use the menu on the popped-out parts or the parent to select 'pop in parts' and return them to their parent.</p>",
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/pop-out-parts.mp4?v=${config.app_version}`,
        imageHeight: '203.72',
        imageType: 'video',
        key: 'pop-out',
        category: 'organization',
      },
      {
        title: 'Attach a card to another',
        text: '<p>Drag and drop a card onto another to add it as a part.</p>',
        imageUrl: `/images/attach.mp4?v=${config.app_version}`,
        imageHeight: '218',
        imageType: 'video',
        key: 'attach',
        category: 'organization',
      },
      {
        title: 'Detach a card from another',
        text: `<p>Drag and drop a card off of another to remove it as a part.</p><p>Or select the "detach part" option from the card menu.</p>`,
        imageUrl: `/images/detach.mp4?v=${config.app_version}`,
        imageHeight: '244',
        imageType: 'video',
        key: 'detach',
        category: 'organization',
      },
      {
        title: 'Reorder parts',
        text: '<p>Drag and drop parts within a card to reorder them.</p>',
        imageUrl: `/images/reorder.mp4?v=${config.app_version}`,
        imageHeight: '379',
        imageType: 'video',
        key: 'reorder',
        category: 'organization',
      },
      {
        title: 'Resize Card',
        text: '<p>Resize a card by dragging the handle in the bottom right corner of the card.</p>',
        key: 'resize-card',
        category: 'organization',
      },
      {
        title: 'Shift to lock axis',
        text: '<p>To move your card on a locked vertical or horizontal axis, hold down the shift key on your keyboard while dragging the card.</p>',
        key: 'shift-lock-axis',
        category: 'organization',
      },

      //TODO free part

      {
        title: 'Change line directions',
        text: '<p>Right click on a line to open the menu, then select or deselect the directional arrows to add or remove arrowheads from the line.</p>',
        imageUrl:`https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/change-relationship-direction.png?v=${config.app_version}`,
        imageHeight: '204',
        imageType: 'image',
        key: 'relationship-directions',
        category: 'relationships',
      },
      {
        title: 'Change line styles',
        text: "<p>Click on a line to open a menu and use the style selectors to change the line's color, pattern, and thickness.</p>",
        imageUrl: `/images/relationship_styles.mp4?v=${config.app_version}`,
        imageHeight: '175',
        imageType: 'video',
        key: 'relationship-colors',
        category: 'relationships',
      },
      {
        title: 'Add a card to a line',
        text: '<p>Click on a line to open a menu and choose "Add a card", or double click on a line to add a card.</p>',
        imageUrl: `/images/relationship_cards.mp4?v=${config.app_version}`,
        imageHeight: '265',
        imageType: 'video',
        key: 'relationship-card',
        category: 'relationships',
      },
      {
        title: 'Move a line\'s endpoints',
        text: '<p>Click on a line to highlight it, then grab one of its endpoints and move it to a different card.</p>',
        imageUrl: `/images/relationship_endpoints.mp4?v=${config.app_version}`,
        imageHeight: '226',
        imageType: 'video',
        key: 'relationship-endpoints',
        category: 'relationships',
      },
      {
        title: 'Straighten line',
        text: '<p>Click on a line to open its menu and choose "Straighten Line".</p><p>Or select a line and press shift + \\</p>',
        imageUrl: `/images/straighten.mp4?v=${config.app_version}`,
        imageHeight: '180.26',
        imageType: 'video',
        key: 'straighten-relationship',
        category: 'relationships',
      },

      // TODO free relationship card

      {
        title: "Add media to a card",
        text: `<p>To add an image, GIF, file, or video to your card - drag and drop the file onto a card or open the card menu and select media.</p><p>On a free account you can upload files up to ${FILE_MAX_SIZE / 1000000}MB, and on a pro account you can upload files up to ${SUBSCRIBER_FILE_MAX_SIZE / 1000000}MB.</p>`,
        imageUrl: `/images/add_image_to_card.mp4?v=${config.app_version}`,
        imageHeight: "268",
        imageType: 'video',
        key: 'add-image',
        category: 'media',
      },
      {
        title: "Resize media",
        text: `<p>Hover over your attachment, go to the three-dot menu in its top right corner, and select "resize___."</p>`,
        imageHeight: "245",
        imageType: 'video',
        key: 'resize-image',
        imageUrl: `/images/resize_an_image.mp4?v=${config.app_version}`,
        category: 'media',
      },
      {
        title: "Remove media from a card",
        text: `<p>Hover over your attachment, go to the three-dot menu in its top right corner, and select "delete ___."</p>`,
        imageUrl: `/images/remove_an_image.mp4?v=${config.app_version}`,
        imageHeight: "333",
        imageType: 'video',
        key: "remove-image",
        category: "media",
      },
      {
        title: 'Cut and paste',
        text: `<p>Press <span class='bold'>${meta} + x</span> to cut, <span class='bold'>${meta} + c</span> to copy, and <span class='bold'>${meta} + v</span> to paste.</p><p>Select a card and press <span class='bold'>${meta} + shift + v</span> to paste a selection inside that card.</p>`,
        imageUrl: `/images/copy_paste.mp4?v=${config.app_version}`,
        imageHeight: '129.2',
        imageType: 'video',
        key: 'cut-paste',
        category: 'hidden',
      },
      {
        title: 'Attach a card to a line',
        text: '<p>Drag an existing card onto a line to attach it as a label.</p>',
        imageUrl: `/images/attach_card_to_relationship.mp4?v=${config.app_version}`,
        imageHeight: '102.75',
        imageType: 'video',
        key: 'relationship-card-attach',
        category: 'hidden'
      },
      {
        title: 'Zoom in or out',
        text: '<p>Use your mouse or trackpad to zoom in or out.</p><p>Or use the zoom slider in the top right-hand corner of the map.</p>',
        imageUrl: `FIX_THIS`,
        imageHeight: '190.74',
        imageType: 'video',
        key: 'zoom',
        category: 'hidden',
      },
      {
        title: 'What is a perspective?',
        text: `<p>A perspective lets you filter and describe cards on your map from a specific point of view.
        <br/>
        The <i class="material-icons va-m" style="margin-right: 0px; color: #a5e27c;">visibility</i> eye icon identifies who or what is taking the perspective.
        <br/>
        The <i class="fa fa-circle p-dot" style="font-size: 12px; color: #a5e27c;"></i> dot icons identify cards that are seen in the point of view
        <br/>
        The <i class="toolbar-icons perspective-annotation va-m" style="display: inline-block;"></i> perspective note lets you describe the view of the perspective-taker on a specific card.</p>`,
        key: 'what-is-p',
        category: 'perspectives',
      },
      {
        title: 'Create a perspective',
        text: '',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/Create-a-p.mp4`,
        imageHeight: '190.74',
        imageType: 'video',
        key: 'create-p',
        category: 'perspectives',
      },
      {
        title: 'Add cards to perspectives',
        text: '',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/add-cards-to-p.mp4`,
        imageHeight: '190.74',
        imageType: 'video',
        key: 'add-cards-to-p',
        category: 'perspectives',
      },
      {
        title: 'Focus on a perspective',
        text: '',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/focus-on-p.mp4?${config.app_version}`,
        imageHeight: '190.74',
        imageType: 'video',
        key: 'focus-on-p',
        category: 'perspectives',
      },
      {
        title: 'Add text to a perspective dot',
        text: '',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/add-a-note.mp4`,
        imageHeight: '190.74',
        imageType: 'video',
        key: 'add-a-note',
        category: 'perspectives',
      },
      {
        title: 'Compare perspectives',
        text: '',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/compare-p.mp4?${config.app_version}`,
        imageHeight: '190.74',
        imageType: 'video',
        key: 'compare-p',
        category: 'perspectives',
      },
      {
        title: 'About Slides',
        text: `<p>Slides enable you to navigate quickly to different cards or regions of cards.  A sequence of waypoints can serve as a lightweight presentation or guided walkthrough of the map.</p>`,
        key: 'waypoints',
        imageType: 'video',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/about-waypoints.mp4?${config.app_version}`,
        imageHeight: '190.74',
        category: 'waypoints',
      },
      {
        title: 'Create a Waypoint',
        text: `<p>You can create a waypoint in three different ways: select "add waypoint" in the waypoints sidebar and adjust the selection box around the cards you'd like to include in your waypoint, select "create a waypoint" in a card's more actions menu, or select a card and then select "add a waypoint" in the waypoints sidebar. select "create a waypoint" in a card's more actions menu, or select a card and then select "add a waypoint" in the waypoints sidebar.</p>`,
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/create-a-waypoint.mp4?${config.app_version}`,
        imageHeight: '190.74',
        imageType: 'video',
        key: 'add-a-waypoint',
        category: 'waypoints',
      },
      {
        title: 'Edit Waypoint Content',
        text: `<p>To edit the content of a waypoint select the waypoint's menu and click "edit." Then adjust the selection box freely.</p>`,
        key: 'edit-waypoint-content',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/edit-waypoint-content.mp4?${config.app_version}`,
        imageHeight: '190.74',
        imageType: 'video',
        category: 'waypoints',
      },
      {
        title: 'Reorder Waypoints',
        text: `<p>To reorder waypoints, drag and drop them within the waypoints sidebar.</p>`,
        key: 'reorder-waypoints',
        category: 'waypoints',
      },
      {
        title: 'Delete All Slides',
        text: `<p>Go to the menu on the waypoints sidebar and select "delete all waypoints."</p>`,
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/delete-all-waypoints.mp4?${config.app_version}`,
        imageHeight: '190.74',
        imageType: 'video',
        key: 'delete-all-waypoints',
        category: 'waypoints',
      },
      {
        title: 'Share a Presentation',
        text: `<p>Use the following URL to share a version of this map which will start presenting waypoints once the map is loaded:</p><p><tt class='focusable' style="background: #f6f6f6; padding: 2px">https://plectica.com/maps/${access.publicIdentifier}?present=1</tt></p>`,
        key: 'share-a-presentation',
        category: 'waypoints',
        nofaq: true,
      },
      {
        title: 'Present Slides',
        text: `<p>To present a map, select "start presentation" in the waypoints sidebar more actions menu, or select the waypoint you'd like to begin with.</p><p>You can navigate through the presentation using the arrows on your keyboard, or the controls at the bottom of your map.</p>`,
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/present-waypoints.mp4?${config.app_version}`,
        imageHeight: '190.74',
        imageType: 'video',
        key: 'present-waypoints',
        category: 'waypoints',
      },

      // attributes
      {
        title: 'About Attributes',
        text: '<p>Attributes allow you to add more informational detail about cards.</p><p>Use them as additional metadata and labels, and as a tool for categorizing and filtering.</p>',
        key: 'about-attributes',
        category: 'attributes',
        imageHeight: '341.23',
        imageType: 'image',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/about-attributes.png`,
      },
      {
        title: 'Add an attribute',
        text: `<p>In the card menu, hover over "attributes," enter an attribute name, and then an attribute value. Hit enter on your keyboard to add the attribute to your card.</p>`,
        key: 'add-attribute',
        category: 'attributes',
        imageType: 'video',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/add-an-attribute.mp4`,
        imageHeight: '121',
      },
      {
        title: 'Edit an attribute',
        text: '<p>Double-click or right-click on an attribute to edit it.</p>',
        key: 'edit-attribute',
        category: 'attributes',
        imageType: 'video',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/edit-an-attribute.mp4`,
        imageHeight: '183.05',
      },
      {
        title: 'Focus on an attribute',
        text: '<p>Open the attributes sidebar and select the attribute you would like to focus on or filter by.</p>',
        key: 'focus-attribute',
        category: 'attributes',
        imageType: 'video',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/focus-on-an-attribute.mp4`,
        imageHeight: '265.44',
      },
      {
        title: 'Delete an attribute',
        text: '<p>Double-click or right-click on an attribute to remove it from the card.</p>',
        key: 'delete-attribute',
        category: 'attributes',
        imageType: 'video',
        imageHeight: '253.93',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/delete-an-attribute.mp4`,
      },
      {
        title: 'About Regions',
        text: '<p>Regions allow you to add resizable and overlapping containers on the canvas behind your cards.</p> <p>Use them to organize the contents of your map and create color-coded groupings of cards.</p>',
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/about-regions.png`,
        imageType: 'image',
        key: 'about-regions',
        category: 'regions',
      },
      {
        title: 'Create a region',
        text: `<p>Use regions to identify sections of the canvas.</p><p>You can create a region in three different ways: click the region icon in the sidebar, click and drag the region icon from the sidebar onto the canvas, or right click and select "create a region."</p>`,
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/create-a-region.mp4`,
        imageType: 'video',
        key: 'create-region',
        category: 'regions',
      },
      {
        title: 'Move a region',
        text: `<p>To reposition a region, drag the shaded title bar near the top border of the region.</p> <p>To reposition a region and everything inside it, <span class="bold"><nobr>${meta}-click</nobr></span> to select the region and all its contents. Then, drag to reposition and the entire selection will move together.</p>`,
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/move-a-region.mp4`,
        imageType: 'video',
        key: 'move-region',
        category: 'regions',
      },
      {
        title: 'Resize a region',
        text: "<p>To change the size a region, drag the resize handles that appear when hovering over any of the region's edges.</p>",
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/resize-a-region.mp4`,
        imageType: 'video',
        key: 'resize-region',
        category: 'regions',
      },
      {
        title: 'Delete a region',
        text: '<p>Delete a region by right clicking inside the region and selecting "Delete region" from the right-click menu</p><p>Or select "Delete region" when expanding the three dot menu at the top right corner of the region.</p>',
        key: 'delete-region',
        category: 'regions',
      },
      {
        //In the card menu, hover over "attributes," enter an attribute name, and then an attribute value. Hit enter on your keyboard to add the attribute to your card.
        title: 'Add a comment',
        text: "<p>In the card menu, click Add Comment to add a comment.</p><p>You can also right-click on the canvas to add a comment to the canvas, or add a comment in the Comments sidebar.</p>",
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/add-a-comment.png`,
        imageType: 'image',
        key: 'add-a-comment',
        category: 'comments',
      },
      {
        title: 'Reply to a comment',
        text: "<p>Click Reply on a comment to add a reply to that comment.</p>",
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/reply-comment.png`,
        imageType: 'image',
        key: 'reply-comment',
        category: 'comments',
      },
      {
        title: 'Add a reaction',
        text: "<p>Click Add reaction on a comment to add a thumbs-up or thumbs-down reaction.</p>",
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/add-reaction.png`,
        imageType: 'image',
        key: 'add-reaction',
        category: 'comments',
      },
      {
        title: 'View all comments in the map',
        text: "<p>Open the Comments sidebar to view all the comments in the map.</p>",
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/view-all-comments-in-map.png`,
        imageType: 'image',
        key: 'view-all-comments-in-map',
        category: 'comments',
      },
      {
        title: 'Hide comments on map',
        text: "<p>Open the Comments sidebar to toggle the visibility of comments on your map.</p>",
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/hide-comments-on-map.png`,
        imageType: 'image',
        key: 'hide-comments-on-map',
        category: 'comments',
      },
      {
        title: 'Edit a comment',
        text: "<p>Open the menu on a comment and navigate to Edit comment.</p><p>Note: You can only edit your own comments.</p>",
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/edit-comment.png`,
        imageType: 'image',
        key: 'edit-comment',
        category: 'comments',
      },
      {
        title: 'Resolve a comment',
        text: "<p>Open the menu on a comment and navigate to Resolve comment.</p>",
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/resolve-comment.png`,
        imageType: 'image',
        key: 'resolve-comment',
        category: 'comments',
      },
      {
        title: 'Re-open a comment',
        text: "<p>Open the Comments sidebar to view all the comments in the map. Open the menu on a resolved comment and navigate to Re-open comment.</p>",
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/reopen-comment.png`,
        imageType: 'image',
        key: 'reopen-comment',
        category: 'comments',
      },
      {
        title: 'Delete a comment',
        text: "<p>Open the menu on a comment and navigate to Delete comment.</p><p>Note: You can only delete your own comments. Deleting a comment preserves the replies to that comment.</p>",
        imageUrl: `https://s3.amazonaws.com/plectica-app-assets/onboarding-videos/delete-comment.png`,
        imageType: 'image',
        key: 'delete-comment',
        category: 'comments',
      },
    ];
};
module.exports = {
  helpData
};



// WEBPACK FOOTER //
// ./shared/lib/user-guide.js